import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCartContainer from './Containers/MiniCart.container';
import QuickSearchContainer from './Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import NotificationContainer from './Containers/Notification.container';
import DynamicComponent from './Components/DynamicComponent';
import USPContainer from './Containers/USP.container';
import Squeezebox from './Components/Squeezebox';
import ItemScroll from './Components/ItemScroll';
import VariantSelector from './Components/Product/VariantSelector';
import PopupModal from './Components/PopupModal';
import TextImageSlider from "./Components/MultiCarousel";
import ProductScroll from "./Components/ProductBannerBlockSlider/ProductScroll";
import { headerScrollCss } from './Components/HeaderScrollCss';
import ConfiguratorSection from './Components/Configurator/ConfiguratorSection';
import ProductSummaryModule from './Components/Configurator/Modules/ProductSummaryModule';
import ConfiguratorAddToCartPopUp from './Components/Configurator/ConfiguratorAddToCartPopUp';
import ConfiguratorMoreProductInfoPopUp from './Components/Configurator/ConfiguratorMoreProductInfoPopUp';
import ConfiguratorShareData from './Components/Configurator/ConfiguratorShareData';
import QuantityCalculatorSelect from './Components/QuantityCalculatorSelect';
import QuantityCalculatorMoreProductInfoPopUp from './Components/QuantityCalculatorMoreProductInfoPopUp';

window.onscroll = function () {
    headerScrollCss();
};

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const bootstrapComponents = () => {
    if (document.getElementById('miniCart')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiniCartContainer />
            </Provider>,
            document.getElementById('miniCart')
        );
    }
    if (document.getElementById('quickSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <QuickSearchContainer />
            </Provider>,
            document.getElementById('quickSearch')
        );
    }
    if (document.getElementById('navbar')) {
        ReactDOM.render(
            <Provider store={store}>
                <NavigationContainer />
            </Provider>,
            document.getElementById('navbar')
        );
    }
    if (document.getElementById('facetedSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchContainer />
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }
    if (document.getElementById('facetedSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchContainer />
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }
    if (document.querySelectorAll('.js-item-scroll').length > 0) {
        Array.from(document.querySelectorAll('.js-item-scroll')).forEach((block) => {
            const model = (block.dataset && block.dataset.items) ? JSON.parse(block.dataset.items) : null;
            const { title, mainTitle, itemType, color, link, linkText, fullWidth, buttonColor, hasBackgroundColor } = block.dataset;
            ReactDOM.render(
                <ItemScroll title={title} mainTitle={mainTitle} items={model} itemType={itemType} color={color} link={link} linktext={linkText} fullwidth={fullWidth} buttonColor={buttonColor} hasBackgroundColor={hasBackgroundColor} />,
                block
            );
        });
    }
    if (document.querySelectorAll('.js-variant-selector').length > 0) {
        Array.from(document.querySelectorAll('.js-variant-selector')).forEach((block) => {
            const model = (block.dataset && block.dataset.items) ? JSON.parse(block.dataset.items) : null;
            const { title, itemType } = block.dataset;
            ReactDOM.render(
                <VariantSelector title={title} items={model} itemType={itemType} />
                ,
                block
            );
        });
    }
    if (document.getElementById('squeezeboxContainer')) {
        const rootElement = document.getElementById('squeezeboxContainer');
        Array.from(rootElement.querySelectorAll('.squeezebox-item')).forEach((row) => {
            const { title, isOpen, isUsp } = row.dataset;
            const html = row.innerHTML;
            ReactDOM.render(
                <Squeezebox {...{ title, html, isOpen, isUsp }} />,
                row
            );
        });
    }
    if (document.querySelectorAll('.product-detail__quantity-wrapper').length > 0) {
        const ProductQuantity = DynamicComponent({
            loader: () => import('./Components/ProductQuantity')
        });
        Array.from(document.querySelectorAll('.product-detail__quantity-wrapper')).forEach((quantityItem, index) => {
            const wholePallet = quantityItem.dataset.wholePallet ? (quantityItem.dataset.wholePallet.toLowerCase() === 'true') : false;
            const minimumQuantity = parseFloat(quantityItem.dataset.minimumQuantity);
            const quantityPerPallet = parseFloat(quantityItem.dataset.quantityPerPallet);
            const unitDecimalDigits = parseFloat(quantityItem.dataset.unitDecimalDigits);
            const { inputId, unit, wholePalletMessage } = quantityItem.dataset;
            const unitList = quantityItem.dataset.unitList ? JSON.parse(quantityItem.dataset.unitList) : [];
            const price = parseFloat(quantityItem.dataset.pricePerUnit).toFixed(2);
            const priceExVat = parseFloat(quantityItem.dataset.pricePerUnitExVat).toFixed(2);
            const priceCampaign = parseFloat(quantityItem.dataset.priceCampaignPerUnit).toFixed(2);
            const priceCampaignExVat = parseFloat(quantityItem.dataset.priceCampaignPerUnitExVat).toFixed(2);
            const currency = quantityItem.dataset.currency ? quantityItem.dataset.currency : '';
            const quantityPerSquareMeter = parseFloat(quantityItem.dataset.quantityPerSquaremeter.replace(",", "."));
            const palletInfo = quantityItem.dataset.palletInfo ? JSON.parse(quantityItem.dataset.palletInfo) : null;
            const isFromProductPage = quantityItem.dataset.isFromProductPage ? (quantityItem.dataset.isFromProductPage.toLowerCase() == 'true') : false;
            const isFromCategoryPage = quantityItem.dataset.isFromCategoryPage ? (quantityItem.dataset.isFromCategoryPage.toLowerCase() == 'true') : false;
            const hasWastage = (quantityItem.dataset.hasWastage.toLowerCase() === 'true');
            const wastagePercent = parseFloat(quantityItem.dataset.wastagePercent);
            const wastageInfo = quantityItem.dataset.wastageInfo ? JSON.parse(quantityItem.dataset.wastageInfo) : null;

            //Fogsand
            let fogFactor = parseFloat(quantityItem.dataset.fogFactor);
            if(quantityItem.dataset.fogFactor) {
                fogFactor = parseFloat(quantityItem.dataset.fogFactor.replace(",", "."));
            }
            let sackWeight = parseFloat(quantityItem.dataset.sackWeight);
            if(quantityItem.dataset.sackWeight) {
                sackWeight = parseFloat(quantityItem.dataset.sackWeight.replace(",", "."));
            }
            const minFogWidth = parseFloat(quantityItem.dataset.minFogWidth);
            const maxFogWidth = parseFloat(quantityItem.dataset.maxFogWidth);
            const minTileThickness = parseFloat(quantityItem.dataset.minTileThickness);
            const maxTileThickness = parseFloat(quantityItem.dataset.maxTileThickness);
            const belowMinTileThickness = quantityItem.dataset.belowMinTileThickness;
            const aboveMaxTileThickness = quantityItem.dataset.aboveMaxTileThickness;
            const belowMinFogWidth = quantityItem.dataset.belowMinFogWidth;
            const aboveMaxFogWidth = quantityItem.dataset.aboveMaxFogWidth;
            const useLinearMeter = quantityItem.dataset.useLinearMeter == "True" ? true : false;
            
            const showCalculator = quantityItem.dataset.showCalculator;
            const showCompressionCheckbox = quantityItem.dataset.showCompressionCheckbox == "True" ? true : false;
            const calculatorVariants = quantityItem.dataset.calculatorVariants ? JSON.parse(quantityItem.dataset.calculatorVariants) : [];
            let density;
            if(quantityItem.dataset.density) {
               density = parseFloat(quantityItem.dataset.density.replace(",", "."));
            }

            ReactDOM.render(
                <Provider store={store}>
                    <ProductQuantity {...{
                        wholePallet,
                        quantityPerPallet,
                        inputId,
                        unit,
                        minimumQuantity,
                        wholePalletMessage,
                        unitDecimalDigits,
                        unitList,
                        price,
                        priceExVat,
                        priceCampaign,
                        priceCampaignExVat,
                        quantityPerSquareMeter,
                        palletInfo,
                        currency,
                        isFromProductPage,
                        isFromCategoryPage,
                        hasWastage,
                        wastagePercent,
                        wastageInfo,
                        fogFactor,
                        minFogWidth,
                        maxFogWidth,
                        minTileThickness,
                        maxTileThickness,
                        sackWeight,
                        belowMinFogWidth,
                        aboveMaxFogWidth,
                        belowMinTileThickness,
                        aboveMaxTileThickness,
                        showCalculator,
                        density,
                        calculatorVariants,
                        showCompressionCheckbox,
                        useLinearMeter
                    }} />
                </Provider>,
                quantityItem
            );

        });
    }
    if (document.getElementById('facetedSearchCompact')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchCompactContainer />
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }
    if (document.getElementById('globalNotification')) {
        ReactDOM.render(
            <Provider store={store}>
                <NotificationContainer />
            </Provider>,
            document.getElementById('globalNotification')
        );
    }

    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }

    if (document.getElementById('myPageQuotations')) {
        const QuotationList = DynamicComponent({
            loader: () => import('./Containers/QuotationList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <QuotationList />
            </Provider>,
            document.getElementById('myPageQuotations')
        );
    }

    if (document.getElementById('google-map')) {
        const GoogleMaps = DynamicComponent({
            loader: () => import('./Components/GoogleMaps')
        });
        const rootElement = document.getElementById('google-map');
        const { lat, lng } = rootElement.dataset;
        ReactDOM.render(
            <GoogleMaps lat={parseFloat(lat)} lng={parseFloat(lng)} />
            ,
            document.getElementById('google-map')
        );
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <AddressList />
            </Provider>,
            document.getElementById('myPageAddresses')
        );
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            document.getElementById('checkout')
        );
    }
    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Containers/LightboxImages.container')
        });
        const rootElement = document.getElementById('lightBoxImages');
        const images = Array.from(rootElement.querySelectorAll('a')).map(img => ({ src: img.dataset.src, alt: img.dataset.alt, labelText: img.dataset.labelText, labelId: img.dataset.labelId, imageHtml: img.dataset.imageHtml }));
        const thumbnails = Array.from(rootElement.querySelectorAll('a img')).map(img => ({ src: img.src, alt: img.alt }));
        ReactDOM.render(
            <Provider store={store}>
                <LightboxImages images={images} thumbnails={thumbnails} />
            </Provider>,
            document.getElementById('lightBoxImages')
        );
    }
    if (document.querySelectorAll('.lightBoxModal').length > 0) {
        const LightboxModal = DynamicComponent({
            loader: () => import('./Containers/LightBoxModal.container')
        });

        Array.from(document.querySelectorAll('.lightBoxModal')).forEach((lightBoxModal) => {
            const images = Array.from(lightBoxModal.querySelectorAll('a')).map(img => ({ src: img.dataset.src, alt: img.dataset.alt, imageHtml: img.dataset.imageHtml }));
            const thumbnails = Array.from(lightBoxModal.querySelectorAll('a img')).map(img => ({ src: img.src, alt: img.alt }));
            const products = lightBoxModal.nextElementSibling;
            const parent = lightBoxModal.closest('div.dual-block-image');
            const styleclass = lightBoxModal.querySelectorAll('a')[0].dataset.styleclass;
            const isinmobile = lightBoxModal.querySelectorAll('a')[0].dataset.isinmobile;
            ReactDOM.render(
                <Provider store={store}>
                    <LightboxModal images={images} thumbnails={thumbnails} styleclass={styleclass} isinmobile={isinmobile} />
                </Provider>,
                lightBoxModal.parentNode, () => {
                    parent ? parent.append(products) : false;
                }
            );


        });
    }
    if (document.getElementById('usp-container')) {
        const el = document.getElementById('usp-container')
        const items = JSON.parse(el.dataset.items)
        ReactDOM.render(
            <Provider store={store}>
                <USPContainer items={items} />
            </Provider>,
            document.getElementById('usp-container')
        );
    }

    (function renderContractorSearch(elem) {
        if (elem) {
            const ContractorSearch = DynamicComponent({
                loader: () => import("./Containers/ContractorSearch.container")
            });
            const { contractors, options } = elem.dataset;
            ReactDOM.render(
                <Provider store={store}>
                    <ContractorSearch contractors={JSON.parse(contractors)} options={JSON.parse(options)} />
                </Provider>,
                elem
            );
        }
    })(document.getElementById("contractor-search"));

    if (document.querySelectorAll('.read-more').length > 0) {
        const ReadMore = DynamicComponent({
            loader: () => import('./Components/ReadMore')
        });

        Array.from(document.querySelectorAll('.read-more')).forEach((readmore) => {
            const { text, readMore, readLess } = readmore.dataset;
            const lines = parseInt(readmore.dataset.lines);
            ReactDOM.render(
                <ReadMore {...{ text, lines, readMore, readLess }} />
                ,
                readmore
            );
        });
    }
    var addToCart = document.getElementById('addToCartPopup');
    if (addToCart) {
        const AddToCartPopupContainer = DynamicComponent({
            loader: () => import('./Containers/AddToCartPopup.container')
        });

        ReactDOM.render(
            <Provider store={store}>
                <AddToCartPopupContainer />
            </Provider>,
            addToCart
        );
    }

    let popupDialogs = document.querySelectorAll('.popup-dialog');
    if (popupDialogs.length > 0) {
        Array.from(popupDialogs).forEach((popup) => {
            const model = (popup.dataset && popup.dataset.model) ? JSON.parse(popup.dataset.model) : null;
            ReactDOM.render(
                <Provider store={store}>
                    <PopupModal {...{ model }} />
                </Provider>,
                popup
            );
        });
    }
    if (document.querySelectorAll(".js-slider-block").length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/SliderBlock')
        });
        Array.from(document.querySelectorAll(".js-slider-block")).forEach(
            (block) => {
                const model =
                    block.dataset && block.dataset.items
                        ? JSON.parse(block.dataset.items)
                        : null;
                ReactDOM.render(
                    <Provider store={store}>
                        <Slider slider={model} />
                    </Provider>,
                    block
                );
            }
        );
    }
    if (document.querySelectorAll('.slider-carousel').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/SliderBlock')
        });
        Array.from(document.querySelectorAll('.slider-carousel')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {
                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                })
            });
            const options = {
                showStatus: false,
                showThumbs: true,
                infiniteLoop: true,
                showArrows: true,
                // centerSlidePercentage: 90,
                // centerMode: false,
                thumbWidth: 90,
                className: "carousel-with-modal",
                dynamicHeight: true
            };
            if (values.length > 0) {
                ReactDOM.render(
                    <Slider values={values} options={options} />,
                    slider
                );
            }
        });
    }

    if (document.querySelectorAll('buy-button').length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Containers/BuyButton.container')
        });
        Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
            const { articleNumber, quantityFieldId, href, cssClass, label, price, productName } = button.dataset;
            ReactDOM.render(
                <Provider store={store}>
                    <BuyButton {...{ label, articleNumber, quantityFieldId, href, cssClass, price, productName }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.Container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const { cssClass, orderId, title } = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <ReorderButton {...{ label, title, cssClass, orderId }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll(".multi-carousel").length > 0) {
        Array.from(document.querySelectorAll(".multi-carousel")).forEach(
            (block) => {
                const model =
                    block.dataset && block.dataset.items
                        ? JSON.parse(block.dataset.items)
                        : null;
                ReactDOM.render(
                    <Provider store={store}>
                        <TextImageSlider items={model} />
                    </Provider>,
                    block
                );
            }
        );
    }
    if (document.querySelectorAll('.js-item-scroll-product').length > 0) {
        Array.from(document.querySelectorAll('.js-item-scroll-product')).forEach((block) => {
            const model = (block.dataset && block.dataset.items) ? JSON.parse(block.dataset.items) : null;
            const { link, linkText, color, buttonColor, hasBackgroundColor } = block.dataset;
            ReactDOM.render(
                <ProductScroll items={model} link={link} linktext={linkText} color={color} buttonColor={buttonColor} hasBackgroundColor={hasBackgroundColor} cssBlock="product-banner-block"/>,
                block
            );
        });
    }

    if (document.querySelectorAll('.js-toggle-class').length > 0) {
        const itemsToToggle = document.querySelectorAll('.js-toggle-class');
        const onToggleClick = (e) => {
            let item = e.currentTarget;
            item.classList.toggle(item.dataset.toggleclass);
        }

        itemsToToggle.forEach(item => {
            item.addEventListener('click', onToggleClick);
        });
    }

    if (document.querySelectorAll(".configurator-wallsection").length > 0) {
        Array.from(document.querySelectorAll(".configurator-wallsection")).forEach(
            (block) => {
                const model =
                    block.dataset && block.dataset.sectioninfo
                        ? JSON.parse(block.dataset.sectioninfo)
                        : null;
                ReactDOM.render(
                    <Provider store={store}>
                        <ConfiguratorSection sectionInfo={model} />
                    </Provider>,
                    block
                );
            }
        );
    }

    if (document.getElementById('summary-module')) {      
        const element = document.getElementById('summary-module');
        const { sharemodalicon, sharemodalheader, sharemodaldescription, sharemodaltipsdescription } = element.dataset;  
        ReactDOM.render(
            <Provider store={store}>
                <ProductSummaryModule shareModalIcon={sharemodalicon} shareModalHeader={sharemodalheader} 
                shareModalDescription={sharemodaldescription} shareModalTipsDescription={sharemodaltipsdescription}/>
            </Provider>,
            document.getElementById('summary-module')
        );
    }

    if (document.getElementById('configuratorAddToCartPopup')) {        
        ReactDOM.render(
            <Provider store={store}>
                <ConfiguratorAddToCartPopUp />
            </Provider>,
            document.getElementById('configuratorAddToCartPopup')
        );
    }

    if (document.getElementById('configuratorMoreProductInfoPopUp')) {        
        ReactDOM.render(
            <Provider store={store}>
                <ConfiguratorMoreProductInfoPopUp />
            </Provider>,
            document.getElementById('configuratorMoreProductInfoPopUp')
        );
    }

    if (document.getElementById('configurator-sharedata')) {   
        const element = document.getElementById('configurator-sharedata');
        const { sharedata } = element.dataset;

        ReactDOM.render(
            <Provider store={store}>
                <ConfiguratorShareData sharedata={sharedata}/>
            </Provider>,
            document.getElementById('configurator-sharedata')
        );
    }

    if (document.getElementById('quantity-calculator-select')) {
        const element = document.getElementById('quantity-calculator-select');
        const { products } = element.dataset;
        ReactDOM.render(
            <Provider store={store}>
                <QuantityCalculatorSelect products={JSON.parse(products)} />
            </Provider>, element
        );
    }

    if (document.getElementById('quantityCalculatorMoreProductInfoPopUp')) {        
        ReactDOM.render(
            <Provider store={store}>
                <QuantityCalculatorMoreProductInfoPopUp />
            </Provider>,
            document.getElementById('quantityCalculatorMoreProductInfoPopUp')
        );
    }
}

bootstrapComponents();
